export default __webpack_public_path__ + "static/media/plus1.be2db159.svg";